export default "__VITE_ASSET__Ct4F$luc__"